import { Nullable } from "../../../../../types/utils";
import { TApiOrderDetails } from "../../../../api/endpoints/Order";
import { TApiServicePackage } from "../../../../api/endpoints/ServicePackage";
import { TApiServiceCharge } from "../../../../api/endpoints/ServiceCharge";
import React, { Fragment, useCallback } from "react";
import { Button, ListGroup } from "react-bootstrap";
import classNames from "classnames";
import { TApiVolumeBand } from "../../../../api/endpoints/VolumeBand";
import { formatCurrency } from "../../../../utils/Format";
import ExternalLink from "../../../Navigation/Links/ExternalLink";

const servicePackageFeatures = (servicePackage: TApiServicePackage): Array<string> => {
  try {
    return servicePackage.features;
  } catch (error) {
    return [];
  }
}

const ServiceChargePrice = (props: {
  serviceCharge: TApiServiceCharge;
  volumeBand: TApiVolumeBand;
}) => {
  const { serviceCharge, volumeBand } = props;
  const serviceChargePrice = serviceCharge.charge_in_eur / 100;
  const volumeBandPrice = volumeBand.charge_in_eur / 100;
  const packagePrice = serviceChargePrice - volumeBandPrice;

  return (
    <div className="service-charge-price">
      <div className="price">
        {formatCurrency(serviceChargePrice, 0)}
      </div>
      <div className="price-details">
        ({formatCurrency(packagePrice, 0)} + {formatCurrency(volumeBandPrice, 0)} Volume Band cost)
      </div>
    </div>
  )
}

const FEATURE_LIST_PER_VERSION_MAP:  Record<TApiOrderDetails['cost']['version'], Nullable<string>> = {
  v1: null,
  v2: null,
  v3: 'https://confluence.ecmwf.int/display/DAC/Service+Charges%3A+01+July+2022+-+01+July+2024',
  v4: 'https://confluence.ecmwf.int/display/DAC/Service+Charges%3A+From+01+July+2024',
  v5: null,
  v6: null
}


const ServicePackageItem = (props: {
  order: TApiOrderDetails;
  servicePackage: TApiServicePackage;
  volumeBand: TApiVolumeBand;
  onSelect: (servicePackage: TApiServicePackage) => void;
  selected: boolean;
  serviceCharge?: TApiServiceCharge;
}) => {
  const {
    order,
    servicePackage,
    serviceCharge,
    volumeBand,
    onSelect,
    selected
  } = props;
  const isAvailable = Boolean(serviceCharge);
  const allServicesLink = FEATURE_LIST_PER_VERSION_MAP[order.cost.version];

  const onSelectClick = useCallback(() => {
    onSelect(servicePackage);
  }, [onSelect, servicePackage]);

  return (
    <div
      className={classNames("service-package-picker-item", selected && 'selected', isAvailable && 'available')}
    >
      <div className="title">
        {servicePackage.title}
      </div>

      <div className="fees">
        {
          serviceCharge ?
            <ServiceChargePrice serviceCharge={serviceCharge} volumeBand={volumeBand} />
            : <Fragment>N/A</Fragment>
        }
      </div>

      <div>
        <ListGroup className="feature-list">
          {
            servicePackageFeatures(servicePackage).map(item => <ListGroup.Item key={item}>{item}</ListGroup.Item>)
          }
          {
            allServicesLink &&
            <ListGroup.Item>
              <ExternalLink url={allServicesLink}>
                Complete list of available services
              </ExternalLink>
            </ListGroup.Item>
          }
        </ListGroup>
      </div>

      <div className="actions">
        <Button onClick={onSelectClick} disabled={!isAvailable} variant={selected ? 'success' : 'primary'}>
          {selected ? 'Selected' : 'Select'}
        </Button>
      </div>
    </div>
  )
}

export default ServicePackageItem;
